import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@services/route.service';
import { Router as ngRouter } from '@angular/router';
import { UiModule } from '@components/ui/ui-module';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { User as UserService } from '@services/user.service';

@Component({
  selector: 'lgb-login',
  imports: [
    UiModule,
    RouterModule,
    FormsModule
  ],
  templateUrl: './login.html',
  styleUrl: './login.css',
})
export class Login{
  //services
  readonly router=inject(Router);
  readonly route=inject(ActivatedRoute);
  readonly userS=inject(UserService);
  private ngRouter=inject(ngRouter);

  //data
  readonly mail=signal<string|null>(null);
  readonly pass=signal<string|null>(null);
  private redirect: string=null;

  //ui
  readonly msg=signal<string | null>(null);
  readonly error=signal<string | null>(null);


  constructor(){
    this.route.queryParamMap.subscribe(params => {
        if(params.get('redirect') && params.get('redirect')!=this.router.get('login'))
          this.redirect=params.get('redirect');
        this.msg.set(((params.has('msg'))? params.get('msg') : null))
      });
  } 

  connect(){
    this.userS.connect(this.mail(), this.pass()).subscribe({
      next: () => {
        if(this.redirect)
          this.ngRouter.navigateByUrl(this.redirect);
        else
          this.router.navigate('collect-home');
      },
      error: e => this.error.set(e)
    });
  }
}
